import { useState, useEffect } from 'react';
import { Input } from '../../../common/Forms/Input/Input';
import { notify } from '../../../../assets/helpers/toast';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as schemas from '../../../../assets/schemas/schemas';
import { ActionButton, AltButton } from '../../../common/Buttons/Buttons';
import { idCodes, planTypes } from '../../../../assets/helpers/options';
import { parsePhoneNumberWithError } from 'libphonenumber-js';
import { customerService } from '../../../../services/customerService';
import { LoadSpinner } from '../../../common/LoadSpinner/LoadSpinner';
import { capitalize, filterParams } from '../../../../assets/helpers/funciones';
import './LandingForms.scss';
import moment from 'moment';

export const FreePersonalInfoForm = (props) => {
  const { setcurentStep, membership, setCustomer, curentStep, code } = props;
  const t = useTranslation();

  const [isLoading, setIsloading] = useState(false);

  const getCustomerById = () => {
    if (
      watch('identificationType') &&
      watch('identification') &&
      watch('identification').length > 5
    ) {
      customerService
        .getCustomerById(watch('identification'), watch('identificationType'))
        .then((response) => {
          if (response.status === 200) {
            const { firstName, lastName, phonePrefix } =
              response?.data?.customer;

            setValue('firstName', capitalize(firstName));
            setValue('lastName', capitalize(lastName));
            setValue('phonePrefix', phonePrefix);
          }
          if (response.status === 404) {
            setValue('firstName', '');
            setValue('lastName', '');
            setValue('state', '');
            setValue('email', '');
            setValue('phonePrefix', '');
          }
        })
        .catch(() => { });
    }
  };

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schemas.CreateFreeCustomerSchema(t)),
  });

  const onSubmit = handleSubmit(async (data) => {
    // let prefix = data.phonePrefix;
    // let number = data.phoneNumber;
    data.firstName = capitalize(data?.firstName);
    data.lastName = capitalize(data?.lastName);
    data.email = data?.email?.toLowerCase();

    if (data.phone) {
      const parsedPhone = parsePhoneNumberWithError(data.phone);
      data.phoneNumber = parsedPhone.nationalNumber;
      data.phonePrefix = '+' + parsedPhone.countryCallingCode;
    }

    // delete data.phoneNumber;
    // delete data.phonePrefix;
    delete data?.countryCode;
    delete data?.phone;

    let fileTopost = appendFile(filterParams(data));
    let user = { ...data };

    // fileTopost.append('phoneNumber', prefix + number);
    // fileTopost.append('phonePrefix', '+58');

    if (
      [planTypes?.PLUSF4, planTypes?.GOLDF4, planTypes?.GOLDENP]?.includes(code)
    ) {
      sessionStorage?.setItem('identification', data?.identification);
    }

    if (!isLoading) {
      setIsloading(true);
      customerService
        .createCustomer(fileTopost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            setIsloading(false);
            sessionStorage.setItem('personalData', JSON.stringify(user));
            setCustomer(response?.data?._id);
            setcurentStep(3);
          } else {
            setIsloading(false);
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch(() => {
          setIsloading(false);
        });
    }
  });

  const appendFile = (data) => {
    const formData = new FormData();
    for (const key in data) {
      formData.append(key, data[key]);
    }

    formData.append('membership', membership?._id);

    return formData;
  };

  const prelaodData = () => {
    let personalData = sessionStorage.getItem('personalData');
    personalData = JSON.parse(personalData);
    if (personalData) {
      setValue('firstName', personalData?.firstName);
      setValue('lastName', personalData?.lastName);
      setValue('phonePrefix', personalData?.phonePrefix);
      setValue('phoneNumber', personalData?.phoneNumber);
      setValue('phone', personalData?.phonePrefix + personalData?.phoneNumber);
      setValue('identificationType', personalData?.identificationType);
      setValue('identification', personalData?.identification);
      setValue('email', personalData?.email);
      setValue(
        'birthday',
        moment(personalData?.birthday)?.format('YYYY-MM-DD')
      );
      setValue('identificationType', personalData?.identificationType);
      setValue('gender', personalData?.gender);
      setValue('maritalStatus', personalData?.maritalStatus);

      setValue('identificationType', personalData?.identificationType);
    }
  };
  // const { getRootProps, getInputProps } = useDropzone({ onDrop: onDrop1 });
  // const { getRootProps: getRootProps2, getInputProps: getInputProps2 } =
  //   useDropzone({
  //     onDrop: onDrop2,
  //   });

  useEffect(() => {
    prelaodData();
  }, []);

  let validateDisabled = () => {
    return !watch('identificationType') || !watch('identification');
  };

  return (
    <>
      <LoadSpinner show={isLoading} />
      <div className="landing-form-container">
        <h5>Información Personal</h5>
        <p>(*) Campos obligatorios</p>
        <br />
        <form>
          <div className="row">
            <Input
              bootstrap={'col-4 col-sm-2 col-md-2'}
              label={'C.I / RIF*'}
              type={'select'}
              name={'identificationType'}
              register={register}
              placeholder={''}
              options={idCodes}
              errors={errors?.identificationType?.message}
              onChange={getCustomerById}
            />{' '}
            <Input
              bootstrap={'col-8 col-sm-4 col-md-4'}
              label={''}
              type={'number'}
              name={'identification'}
              register={register}
              placeholder={''}
              errors={errors?.identification?.message}
              onChange={getCustomerById}
              numpadForMobile={true}
            />{' '}
            <Input
              bootstrap={'col-12 col-md-6'}
              label={'Correo Electrónico *'}
              type={'text'}
              name={'email'}
              register={register}
              placeholder={''}
              errors={errors?.email?.message}
              disabled={validateDisabled()}
            />
            <Input
              bootstrap={'col-12 col-md-6'}
              label={'Nombre *'}
              type={'text'}
              name={'firstName'}
              register={register}
              placeholder={''}
              errors={errors?.firstName?.message}
              disabled={validateDisabled()}
            />
            <Input
              bootstrap={'col-12 col-md-6'}
              label={'Apellido *'}
              type={'text'}
              name={'lastName'}
              register={register}
              placeholder={''}
              errors={errors?.lastName?.message}
              disabled={validateDisabled()}
            />{' '}
            <Input
              bootstrap={'col-12 col-md-6'}
              label={'Teléfono *'}
              type={'phone'}
              control={control}
              name={'phone'}
              register={register}
              placeholder={''}
              errors={errors?.phone?.message}
              disabled={validateDisabled()}
              numpadForMobile={true}
            />
          </div>

          <div
            style={{ margin: '24px 0px 48px 0px' }}
            className="buttons-center-container"
          >
            <AltButton
              label={'Regresar'}
              action={() => setcurentStep(curentStep - 1)}
            />
            <ActionButton label={'Siguiente'} action={onSubmit} />
          </div>
        </form>
      </div>
    </>
  );
};
